'use client';

import React from 'react';

interface SkipLinkProps {
  href?: string;
  label?: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({
  href = '#main-content',
  label = 'Skip to main content'
}) => {
  return (
    <a data-component-id="src/components/common/SkipLink.tsx:15:4" data-component-path="src/components/common/SkipLink.tsx" data-component-line="15" data-component-end-line="26" data-component-file="SkipLink.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22className%22%3A%22sr-only%20focus%3Anot-sr-only%20focus%3Aabsolute%20focus%3Az-%5B9999%5D%20focus%3Atop-4%20focus%3Aleft-4%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20focus%3Apx-%5Bvar(--space-4)%5D%20focus%3Apy-%5Bvar(--space-3)%5D%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20focus%3Abg-%5Bvar(--text-1)%5D%20focus%3Atext-%5Bvar(--bg)%5D%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20focus%3Arounded-%5Bvar(--radius-2)%5D%20focus%3Ashadow-%5Bvar(--shadow-3)%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20focus%3Aoutline-none%20focus%3Aring-4%20focus%3Aring-%5Bvar(--focus)%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20font-medium%20text-%5Bvar(--font-size-3)%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20transition-all%20duration-200%22%7D"
      href={href}
      className="sr-only focus:not-sr-only focus:absolute focus:z-[9999] focus:top-4 focus:left-4 
                 focus:px-[var(--space-4)] focus:py-[var(--space-3)] 
                 focus:bg-[var(--text-1)] focus:text-[var(--bg)] 
                 focus:rounded-[var(--radius-2)] focus:shadow-[var(--shadow-3)]
                 focus:outline-none focus:ring-4 focus:ring-[var(--focus)]
                 font-medium text-[var(--font-size-3)]
                 transition-all duration-200"
    >
      {label}
    </a>
  );
};

export default SkipLink;